
export default {
  props: {
    profile: {
      type: Object,
    },

    inFavorites: {
      type: Boolean,
      default: false,
    },

    isFavoriteProcessing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },

  computed: {
    linkToTwitter() {
      let link;

      if (this.profile) {
        link = `http://twitter.com/share?text=Some text about this model&url=${this.$config.baseUrlApp}/${this.profile.slug}`;
      }

      return link;
    },

    updatesLink() {
      return `/escorts-updates/${this.profile.slug}`;
    },
  },

  methods: {
    openBookMe() {
      this.$root.$emit("book-me-modal:open", this.profile.slug);
    },

    openMessageDialog() {
      if (this.$auth.loggedIn) {
        this.isMenuOpen = false;
        this.$root.$emit("open-message-dialog", this.profile);
        return;
      }
      this.redirectAuth();
    },

    openReportModal() {
      if (this.$auth.loggedIn) {
        this.$root.$emit("openReportProfileModal", this.profile);
        return;
      }
      this.redirectAuth();
    },

    addToFavorite() {
      if (this.$auth.loggedIn) {
        this.$emit("favoriteClicked", {
          ...this.profile,
          isFavorite: this.inFavorites,
        });
        return;
      }

      this.redirectAuth();
    },

    redirectAuth() {
      if (window.innerWidth < 1024) {
        this.$root.$emit("sign-in-drawer:open");
      } else {
        this.$router.push({ name: "auth-signin" });
      }
    },
  },
};
